<template>
    <div class="footer">
      <div class="container">
        <div class="foot-content">
          <div class="row">
            <div class="col-md-2 inline-block">
              <div class="about">
                <h4>关于我们</h4>
                <ul>
                  <li><router-link :to="{name: 'aboutUs'}">公司介绍</router-link></li>
                  <li><router-link :to="{name: 'developmentHistory'}">发展历程</router-link></li>
                  <li><router-link :to="{name: 'newList', query: {page: 1}}">新闻中心</router-link></li>
                  <li><router-link :to="{name: 'contactOurs'}">联系我们</router-link></li>
                  <li><a href="http://app.kcsoft.com.cn/Articles/Show/1">隐私政策</a></li>
                </ul>
              </div>
            </div>
            <div class="col-md-3 inline-block">
              <div class="qq">
                <h4>在线客服</h4>
                <a class="btn qq-service" target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=3129390793&amp;site=qq&amp;menu=yes">
                  <i class="qq-logo"></i>
                  <span>在线客服</span>
                </a>
              </div>
            </div>
            <div class="col-md-3 inline-block">
              <div class="contact">
                <h4>联系方式</h4>
                <p>
                  地址：广州市萝岗区科珠路232号益民科技园3栋207
                </p>
                <p>电话：<span>020-87590536</span></p>
                <p>传真：<span>020-87578114</span></p>
              </div>
            </div>
            <div class="col-md-1 inline-block"></div>
            <div class="col-md-3 inline-block">
              <div class="code">
                <img src="../assets/image/comment/code.png" alt="微信公众号">
                <p>微信公众号</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="foot-bottom">
        <div class="friendship">
          <div class="container">
            <ul>
              <li>
                <span>友情链接:</span>
              </li>
              <li>
                <a href="http://www.kujiale.com/" target="_blank">酷家乐</a>
              </li>
              <li>
                <a href="http://www.dingdang2112.com/" target="_blank">极家小叮3D签单神器</a>
              </li>
              <li>
                <a href="http://www.zsgl.net/" target="_blank">精打细算ERP管理</a>
              </li>
              <li>
                <a href="http://www.lohas-deco.com/qd/index.html" target="_blank">乐豪斯</a>
              </li>
              <li>
                <a href="http://zztx.cn/" target="_blank">智装天下</a>
              </li>
              <li>
                <a href="http://apple2003.bmt.bqqm.com/" target="_blank">湖南苹果装饰集团</a>
              </li>
              <li>
                <a href="http://www.whhyjzzs.com/" target="_blank">汉屿装饰</a>
              </li>
              <li>
                <a href="http://www.sdlcjt.com/" target="_blank">四川生活家</a>
              </li>
              <li>
                <a href="http://xqzjyzx.zq.gezlife.com/" target="_blank">喜鹊筑家</a>
              </li>
              <li>
                <a href="http://www.xique.com/" target="_blank">喜鹊生活家具用品</a>
              </li>
              <li>
                <a href="http://www.lsejia.com/" target="_blank">靓尚e家</a>
              </li>

            </ul>
          </div>
        </div>
        <div class="copyright">
          <div class="container">
            <div style="margin:0 auto; padding:10px 0;">
              <small>
                <span class="com-name">广州市科创电脑技术开发有限公司版权所有 <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备12050206号 </a></span>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011602000015" class="file">
                  <img src="../assets/image/comment/police.png">
                  <p>粤公网安备 44011602000015号</p>
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'websiteFooter'
}
</script>

<style scoped>
  /*.footer*/
  .footer{
    background-color: #1E2122;
    padding-top: 30px;
  }
  @media screen and (min-width:992px) {
    .footer{
      background: url('../assets/image/comment/footer-bg.png') no-repeat;
      background-color: #1E2122;
    }
  }

  @media (min-width: 992px) {
    .footer .foot-content>.row{
      display: flex;
      justify-content: space-evenly;
    }
  }

  .footer .foot-content h4,
  .footer .foot-content p,
  .footer .foot-content a{
    color: #ADABAA;
  }
  .footer .foot-content .col-md-3{
  }
  .footer .foot-content h4{
    font-weight: bold;
    margin-bottom: 20px;
  }
  /*about*/
  .footer .foot-content .about,
  .footer .foot-content .qq,
  .footer .foot-content .contact{
    margin-bottom: 30px;
  }
  @media (min-width: 992px){
    .footer .foot-content .about,
    .footer .foot-content .qq,
    .footer .foot-content .contact{
      margin-left: 40px;
    }
  }
  @media (max-width: 991px){
    .footer .foot-content .about,
    .footer .foot-content .qq,
    .footer .foot-content .contact{
      text-align: center;
    }
    .footer .foot-content .qq .btn{
      margin-left: auto;
      margin-right: auto;
    }
  }

  .footer .foot-content .about ul li{
    margin-bottom: 10px;
  }

  /*QQ在线联系*/
  .footer .foot-content .qq a:hover,
  .footer .foot-content .contact p span{
    color: #D5994B;
  }
  .footer .foot-content .qq .qq-logo{
    background: url('../assets/image/comment/QQ.png') no-repeat;
    display: inline-block;
    width: 30px;
    height: 30px;
    background-size: cover;
  }
  .footer .foot-content .qq a.btn{
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-evenly;
    padding: 5px 15px 1px;
    border: 2px solid #ADABAA;
    border-radius: 30px;
    margin-bottom: 10px;
    min-width: 90px;
    width: 124px;

  }

  .footer .foot-content .qq .btn span{
    vertical-align: middle;
    display: inline-block;
  }

  /*contact*/
  .footer .foot-content .contact p{
    text-align: left;
  }
  @media (max-width: 991px){
    .footer .foot-content .contact p{
      text-align: center;
    }
  }
  /*code*/
  .footer .foot-content .code{
    text-align: center;
  }
  .footer .foot-content .code img{
    width: 130px;
    margin-bottom: 10px;
  }

  .footer .foot-content .code p{
    text-align: center;
  }
  .footer .foot-bottom{
    padding-top: 15px;
    padding-bottom: 5px;
    background-color: #1E2122;
    border-top: 1px solid #272822;
  }
  .footer .friendship{
    margin-bottom: 5px;

  }
  /*.footer .friendship ul:after{*/
  /*  clear: both;*/
  /*}*/
  .footer .friendship ul{
    overflow: hidden;
    list-style: none;
    margin: 0
  }
  .footer .friendship ul li {
    display:inline-block;
    float: left;
    margin-right: 10px;
  }
  .footer .friendship ul li span,
  .footer .friendship ul li a,
  .footer .copyright small{
    color: #87888A;
  }
  .footer .friendship ul li a{
    padding-left: 10px;
    border-left: 1px solid #707070;
    color: #87888A;
  }
  /*copyright*/
  .footer .copyright{
    padding-bottom: 5px;
    text-align: center;
  }
  .copyright .com-name a,
  .copyright .file p{
    color: #939393;
  }
  .copyright .com-name {
    display: inline-block;
    line-height: 16px;
    vertical-align: middle;
  }
  .copyright .file {
    display: inline-block;
    line-height: 16px;
  }
  .copyright .file img{
    margin-left: 10px;
  }
  .copyright a:hover{
    text-decoration: none;
  }
  .copyright .file p{
    display: inline-block;
    line-height: 16px;
    margin: 0 0 0 5px;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/websiteFooter.vue